<template>
	<ViewPhoto
		v-if="imageShow && photos.length"
		:key="photosIndex"
		:images="photos"
		:index="photosIndex"
		@close="imageShow = false"
		:name="goal?.name"
	/>
	<div
		class="
			fixed
			inset-y-0
			right-0
			pl-10
			flex
			side-over
			w-720
			z-50
			overflow-y-auto
		"
	>
		<div
			class="h-full w-full flex flex-col bg-white shadow-xl"
			style="min-height: 100vh; height: fit-content"
		>
			<div class="p-6 bg-blue-50">
				<div class="flex items-start justify-between">
					<div class="flex items-center">
						<div class="text-4xl font-bold text-neutral-700 ml-1.5">
							Chi tiết mục tiêu
						</div>
					</div>
					<div class="ml-3 h-7 flex items-center">
						<button
							type="button"
							class="
								rounded-md
								text-neutral-400
								hover:text-neutral-700
							"
							@click="$emit('close')"
						>
							<span class="sr-only">Close panel</span>
							<svg
								class="h-6 w-6"
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								aria-hidden="true"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>
			<div
				v-if="!isLoading"
				class="__goal-management-student-detail p-10 md-down:px-4"
			>
				<div class="__goal-management-student-detail__header">
					<div class="flex justify-between items-center w-full">
						<router-link :to="`/record/student/${student?.id}`">
							<div class="flex items-center">
								<img
									v-if="student?.profile_photo?.w200"
									:src="student?.profile_photo?.w200"
									alt=""
									class="
										shadow-sm
										inline-block
										h-14
										w-14
										rounded-full
									"
									style="min-width: 56px"
								/>
								<span
									v-else
									:style="{
										background:
											student?.profile_photo?.default
												?.color,
									}"
									class="
										inline-flex
										items-center
										justify-center
										h-14
										w-14
										rounded-full
									"
									style="min-width: 56px"
								>
									<span
										class="
											font-medium
											leading-none
											text-white text-4xl
										"
										>{{
											student?.profile_photo?.default
												?.initial
										}}</span
									>
								</span>
								<div class="ml-4">
									<div
										class="
											font-bold
											text-neutral-700 text-4xl
											md-down:text-2xl
										"
									>
										{{ student?.name }}
									</div>
									<div
										v-if="student?.age"
										class="
											text-green-500
											font-semibold
											text-xs
											uppercase
										"
									>
										{{ student?.age }}
										{{
											student?.learning_time
												? `| ${student?.learning_time}`
												: ''
										}}
									</div>
								</div>
							</div>
						</router-link>
						<div
							class="luca-button cursor-pointer"
							@click="router.push(`/goal/${id}/${props.goalId}`)"
						>
							Xem toàn trang
						</div>
					</div>
				</div>
				<div class="bg-white shadow-sm rounded-2xl mt-12">
					<div class="flex items-center justify-between p-6">
						<div class="font-semibold text-neutral-600">
							Nội dung mục tiêu
						</div>
					</div>
					<div class="px-6 pb-6">
						<div class="border p-4 rounded-lg">
							<div class="flex flex-col items-start mb-4">
								<div
									class="
										w-full
										text-neutral-400
										font-semibold
										text-xs
										mb-2
									"
								>
									NỘI DUNG
								</div>
								<div class="w-full">
									<div
										class="text-neutral-600 font-semibold"
										v-html="goal?.name"
									></div>
									<div>
										<div
											class="
												goal-block
												text-sm
												font-medium
												text-neutral-700
												mt-2
											"
											v-if="
												goal?.parent?.sub_goal_count > 0
											"
										>
											<div
												class="flex items-center gap-2"
											>
												<img
													class="w-3 h-3"
													src="@/assets/images/icons/goal-arrow.png"
													alt=""
												/>
												<div>
													{{ goal?.parent.name }}
												</div>
											</div>
											<div
												class="
													text-neutral-400 text-xs
													font-semibold
													mt-2
													flex
													items-center
													gap-2
													ml-5
												"
											>
												<div>
													{{
														goal?.parent
															?.sub_goal_count
													}}
													MỤC TIÊU
												</div>
												<svg
													width="4"
													height="4"
													viewBox="0 0 4 4"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M2.064 3.3C1.644 3.3 1.284 3.156 0.984 2.856C0.684 2.556 0.54 2.196 0.54 1.776C0.54 1.368 0.684 1.02 0.984 0.732C1.284 0.444 1.644 0.3 2.064 0.3C2.472 0.3 2.82 0.444 3.108 0.732C3.396 1.02 3.54 1.368 3.54 1.776C3.54 2.196 3.396 2.556 3.108 2.856C2.82 3.156 2.472 3.3 2.064 3.3Z"
														fill="#94A3B8"
													/>
												</svg>
												<div>KẾT QUẢ</div>
												<div
													class="
														progress-bar
														overflow-hidden
													"
												>
													<div
														:style="{
															background:
																$filters.tagResult(
																	goal?.complete_percent
																)?.background,
															width:
																goal?.complete_percent +
																'%',
														}"
														class="h-full"
													></div>
												</div>
												<div
													class="
														text-neutral-400 text-xs
														font-semibold
													"
												>
													{{
														goal.complete_percent ||
														0
													}}%
												</div>
											</div>
											<div
												class="ml-5 mt-2"
												v-for="g in goal?.parent
													.sub_goals"
												:key="g.id"
											>
												<div class="flex gap-2">
													<img
														class="w-3 h-3 mt-2"
														src="@/assets/images/icons/child-goal.png"
														alt=""
													/>
													<div
														:class="{
															'font-semibold':
																g.id ===
																goal?.id,
														}"
														v-html="g.name"
													></div>
												</div>
												<div
													class="
														ml-5
														flex
														items-center
														gap-2
														mt-2
													"
												>
													<div
														class="
															text-neutral-400
															text-xs
															font-semibold
														"
													>
														KẾT QUẢ
													</div>
													<div
														class="
															progress-bar
															overflow-hidden
														"
													>
														<div
															:style="{
																background:
																	$filters.tagResult(
																		g.complete_percent
																	)
																		?.background,
																width:
																	g.complete_percent +
																	'%',
															}"
															class="h-full"
														></div>
													</div>
												</div>
												<div
													class="
														ml-5
														flex
														items-center
														gap-2
														mt-2
													"
												>
													<div
														class="plan_name"
														v-if="g?.plan_name"
													>
														{{ g?.plan_name }}
													</div>
													<svg
														v-if="g?.plan_name"
														width="4"
														height="4"
														viewBox="0 0 4 4"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M2.064 3.3C1.644 3.3 1.284 3.156 0.984 2.856C0.684 2.556 0.54 2.196 0.54 1.776C0.54 1.368 0.684 1.02 0.984 0.732C1.284 0.444 1.644 0.3 2.064 0.3C2.472 0.3 2.82 0.444 3.108 0.732C3.396 1.02 3.54 1.368 3.54 1.776C3.54 2.196 3.396 2.556 3.108 2.856C2.82 3.156 2.472 3.3 2.064 3.3Z"
															fill="#94A3B8"
														/>
													</svg>
													<div
														v-html="
															getStatus(g?.state)
														"
													></div>
													<div
														class="
															mt-1
															py-0.5
															px-2.5
															rounded-full
															bg-yellow-tag
															text-neutral-700
															h-fit
															w-fit
															font-semibold
															shadow-input
															whitespace-nowrap
														"
														style="font-size: 10px"
														v-if="g?.age"
													>
														{{ g?.age }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="flex flex-col items-start mb-4">
								<div
									class="
										w-full
										text-neutral-400
										font-semibold
										text-xs
										mb-2
									"
								>
									LĨNH VỰC
								</div>
								<div class="text-neutral-600 w-full">
									{{ goal?.skill?.name }}
								</div>
							</div>
							<div
								v-if="org.enable_goal_assistance_level"
								class="flex flex-col items-start mb-4"
							>
								<div
									class="
										w-full
										text-neutral-400
										font-semibold
										text-xs
										mb-2
									"
								>
									MỨC ĐỘ HỖ TRỢ
								</div>
								<div class="w-full">
									<div
										v-for="ass in goal?.assistance_levels"
										:key="ass"
										class="text-neutral-600 mb-2"
									>
										{{ ass || '-' }}
									</div>
								</div>
							</div>
							<div
								v-if="org.enable_goal_reason"
								class="flex flex-col items-start mb-4"
							>
								<div
									class="
										w-full
										text-neutral-400
										font-semibold
										text-xs
										mb-2
									"
								>
									CƠ SỞ HỢP LÝ
								</div>
								<div class="text-neutral-600 w-full">
									{{ goal?.reason || '-' }}
								</div>
							</div>
							<div
								v-if="org.enable_goal_strategy"
								class="flex flex-col items-start mb-4"
							>
								<div
									class="
										w-full
										text-neutral-400
										font-semibold
										text-xs
										mb-2
									"
								>
									CHIẾN LƯỢC
								</div>
								<div class="text-neutral-600 w-full">
									{{ goal?.strategy || '-' }}
								</div>
							</div>
							<div
								v-if="org.enable_goal_process"
								class="flex flex-col items-start mb-4"
							>
								<div
									class="
										w-full
										text-neutral-400
										font-semibold
										text-xs
										mb-2
									"
								>
									QUY TRÌNH THỰC HIỆN
								</div>
								<div
									v-if="goal?.process"
									class="text-neutral-600 w-full"
									style="
										white-space: pre-wrap;
										word-wrap: break-word;
									"
									v-html="goal?.process"
								></div>
								<div class="w-full" v-else>-</div>
							</div>
							<div
								v-if="goal?.path"
								class="flex flex-col items-start mb-4"
							>
								<div
									class="
										w-full
										text-neutral-400
										font-semibold
										text-xs
										mb-2
									"
								>
									THƯ VIỆN
								</div>
								<div class="text-neutral-600 w-full">
									{{ goal?.path }}
								</div>
							</div>
							<div
								v-if="goal?.age"
								class="flex flex-col items-start mb-4"
							>
								<div
									class="
										w-full
										text-neutral-400
										font-semibold
										text-xs
										mb-2
									"
								>
									TUỔI
								</div>
								<div class="text-neutral-600 w-full">
									{{ goal?.age }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="relative my-12">
					<div
						aria-hidden="true"
						class="absolute inset-0 flex items-center"
					>
						<div class="w-full border-t border-neutral-300" />
					</div>
					<div class="relative flex justify-center">
						<div
							class="
								px-2.5
								py-1
								bg-white
								text-neutral-600
								font-semibold
								pb-1
								text-2xl
							"
						>
							Hoạt động
						</div>
					</div>
				</div>
				<div
					v-if="goal?.activities?.length"
					class="shadow-sm sm:rounded-2xl overflow-hidden"
				>
					<div class="__record__table overflow-x-auto scroll-bar">
						<div
							class="
								overflow-hidden
								sm:rounded-t-2xl
								w-fit
								min-w-full
							"
						>
							<table class="min-w-full divide-y text-neutral-200">
								<thead class="bg-neutral-100 h-16">
									<tr>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												w-16
												whitespace-nowrap
											"
											scope="col"
										>
											STT
										</th>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
											"
											scope="col"
										>
											HOẠT ĐỘNG
										</th>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
												relative
											"
											scope="col"
										>
											SỐ LẦN ĐƯỢC DẠY
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(
											activity, i
										) in goal?.activities"
										:key="activity.id"
										:class="
											i % 2 === 0
												? 'bg-white'
												: 'bg-neutral-50'
										"
										class="text-neutral-700"
									>
										<td
											class="
												px-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
										>
											<div class="ml-2">
												{{ i + 1 }}
											</div>
										</td>
										<td
											class="px-6 py-4 text-neutral-700"
											style="width: 50%; min-width: 220px"
										>
											<div class="flex items-center">
												{{ activity.name }}
											</div>
										</td>
										<td class="px-6 py-4 text-neutral-700">
											<div class="flex items-center">
												{{
													activity.activity_used_count ||
													0
												}}
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div v-else class="flex items-center justify-center flex-col">
					<div class="text-center text-neutral-500">
						Mục tiêu này hiện chưa có hoạt động nào được thêm vào.
					</div>
				</div>
				<div class="relative my-12">
					<div
						aria-hidden="true"
						class="absolute inset-0 flex items-center"
					>
						<div class="w-full border-t border-neutral-300" />
					</div>
					<div class="relative flex justify-center">
						<div
							class="
								px-2.5
								py-1
								bg-white
								text-neutral-600
								font-semibold
								pb-1
								text-2xl
							"
						>
							Biểu đồ kết quả học của mục tiêu
						</div>
					</div>
				</div>
				<div>
					<div class="bg-white mt-8 p-6 shadow-sm rounded-2xl">
						<div class="flex">
							<div
								class="bg-green-500 rounded-full mr-4"
								style="
									width: 16px;
									height: 16px;
									min-height: 16px;
									min-width: 16px;
								"
							></div>
							<div
								class="font-semibold text-neutral-500 -mt-1"
								v-html="goal?.name"
							></div>
						</div>
						<div
							class="
								p-6
								border-t border-orange-50
								md-down:px-0
								overflow-x-auto
								w-full
							"
						>
							<apexchart
								:options="chartOptions"
								:series="series_"
								height="500"
								style="min-width: 1000px; width: 100%"
								type="line"
							></apexchart>
						</div>
					</div>
				</div>
				<div class="relative my-12">
					<div
						aria-hidden="true"
						class="absolute inset-0 flex items-center"
					>
						<div class="w-full border-t border-neutral-300" />
					</div>
					<div class="relative flex justify-center">
						<div
							class="
								px-2.5
								py-1
								bg-white
								text-neutral-600
								font-semibold
								pb-1
								text-2xl
							"
						>
							Media của mục tiêu
						</div>
					</div>
				</div>
				<div v-if="goal?.goal_media && goal?.goal_media.length">
					<div
						class="
							grid grid-cols-2
							md:grid-cols-3
							lg:grid-cols-6
							gap-4
						"
					>
						<div
							v-for="i in countMedia(goal)"
							:key="i"
							class="rounded-lg bg-neutral-200 relative"
							style="aspect-ratio: 1"
							@click="openMediaPopup(goal?.goal_media, i - 1)"
						>
							<img
								v-if="
									goal?.goal_media[i - 1]?.asset_type ===
									'image'
								"
								:src="loadImage(goal?.goal_media[i - 1])"
								alt=""
								class="rounded-lg object-cover shadow-lg"
								style="aspect-ratio: 1; height: 100%"
							/>
							<img
								v-else-if="
									loadThumbnail(goal?.goal_media[i - 1])
								"
								:src="loadThumbnail(goal?.goal_media[i - 1])"
								alt=""
								class="rounded-lg object-cover shadow-lg"
								style="aspect-ratio: 1; height: 100%"
							/>
							<div v-else class="relative">
								<img
									alt=""
									class="rounded-lg object-cover shadow-lg"
									src="../../assets/images/background/auth.png"
									style="aspect-ratio: 1; height: 100%"
								/>
							</div>
							<div
								class="absolute inset-0 bg-black opacity-20"
							></div>
							<div
								v-if="
									goal?.goal_media[i - 1]?.asset_type ===
									'video'
								"
								class="absolute flex flex-col items-center"
								style="
									left: 50%;
									top: 50%;
									transform: translate(-50%, -50%);
								"
							>
								<svg
									fill="none"
									height="55"
									viewBox="0 0 55 55"
									width="55"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g opacity="0.5">
										<rect
											fill="black"
											height="54.5"
											rx="27.25"
											width="54.5"
										/>
										<path
											d="M34.4948 28.5672L24.9024 36.9606C23.7709 37.9507 22 37.1471 22 35.6436V18.8568C22 17.3532 23.7709 16.5497 24.9024 17.5397L34.4948 25.9332C35.2917 26.6304 35.2917 27.8699 34.4948 28.5672Z"
											fill="white"
										/>
									</g>
								</svg>
							</div>
							<div
								v-if="goal?.goal_media[i - 1]?.inserted_at"
								class="
									absolute
									bottom-2
									left-4
									z-10
									font-medium
									text-white
								"
							>
								{{
									$filters.formatDate(
										goal?.goal_media[i - 1]?.inserted_at
									)
								}}
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<div class="text-center text-neutral-500">
						Mục tiêu này hiện chưa có hình ảnh / video nào được tải
						lên.
					</div>
				</div>
				<div class="relative my-12">
					<div
						aria-hidden="true"
						class="absolute inset-0 flex items-center"
					>
						<div class="w-full border-t border-neutral-300" />
					</div>
					<div class="relative flex justify-center">
						<div
							class="
								px-2.5
								py-1
								bg-white
								text-neutral-600
								font-semibold
								pb-1
								text-2xl
							"
						>
							Phản hồi
						</div>
					</div>
				</div>
				<div class="mt-14">
					<div v-if="goal && goal.chat_messages?.length">
						<div
							id="feedback-box"
							class="overflow-x-auto scroll-bar--none"
						>
							<div class="flex flex-nowrap gap-8">
								<div
									v-for="g in goal.chat_messages"
									:key="g.id"
								>
									<div
										class="
											flex
											bg-white
											rounded-xl
											border-sm
											p-4
											w-fit
											h-fit
											gap-6
											shadow
											relative
										"
										style="width: 400px"
									>
										<div>
											<svg
												fill="none"
												height="24"
												viewBox="0 0 24 24"
												width="24"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M12.0146 0C5.39191 0 0 5.38537 0 12C0 15.4829 1.5238 18.7902 4.13185 21.0732C5.04027 21.8634 6.0659 22.5073 7.15015 23.0049C8.70325 23.6488 10.3443 24 12.0146 24C13.6849 24 15.3259 23.6488 16.8497 22.9756C17.9633 22.478 18.9596 21.8341 19.868 21.0439C22.5054 18.761 23.9999 15.4537 23.9999 11.9707C24.0292 5.38537 18.6373 0 12.0146 0ZM12.0146 4.47805C14.8864 4.47805 17.2014 6.81951 17.2014 9.65854C17.2014 12.4976 14.8571 14.839 12.0146 14.839C9.17212 14.839 6.82781 12.4976 6.82781 9.65854C6.82781 6.81951 9.14281 4.47805 12.0146 4.47805ZM19.0475 20.9854C18.9596 21.0732 18.8717 21.1317 18.7545 21.2195C18.608 21.3073 18.4908 21.3951 18.3442 21.5122C18.2563 21.5707 18.1684 21.6293 18.0512 21.6878C17.9047 21.7756 17.7288 21.8634 17.5823 21.9512C17.4944 22.0098 17.4065 22.039 17.3479 22.0976C17.1135 22.2146 16.8497 22.361 16.586 22.4488C15.1501 23.0927 13.597 23.4146 12.0146 23.4146C10.4322 23.4146 8.87908 23.0927 7.41388 22.4488C6.41755 22.0098 5.50913 21.4244 4.65932 20.7512C5.36261 18.322 7.64831 16.6244 10.2564 16.6244H13.7728C16.3809 16.6244 18.6373 18.322 19.3406 20.7512C19.2527 20.8098 19.1647 20.8976 19.0475 20.9854Z"
													fill="#F4C870"
												/>
											</svg>
										</div>
										<div>
											<div
												class="
													text-sm text-neutral-400
													absolute
													right-4
													top-4
												"
											>
												{{
													timeSinceHour(g.inserted_at)
												}}
											</div>
											<div
												class="
													font-semibold
													text-yellow-600
													mb-1
												"
											>
												{{
													g?.chat_group_user
														?.elationship_role ||
													'Phụ huynh'
												}}
												bé {{ student?.name || '' }}
											</div>
											<div>
												{{ g.text }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							v-if="scrollable"
							class="flex items-center justify-center mt-10"
						>
							<div
								class="
									h-11
									w-11
									bg-white
									shadow-sm
									rounded-tl-lg rounded-bl-lg
									flex
									items-center
									justify-center
									border-2 border-neutral-200
									cursor-pointer
									hover:bg-yellow-50
								"
								@click="scrollLeft()"
							>
								<svg
									fill="none"
									height="16"
									viewBox="0 0 16 16"
									width="16"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M10 12L6 8L10 4"
										stroke="#48566A"
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="1.33333"
									/>
								</svg>
							</div>
							<div
								class="
									h-11
									w-11
									bg-white
									shadow-sm
									rounded-tr-lg rounded-br-lg
									border-l-0
									flex
									items-center
									justify-center
									border-2 border-neutral-200
									cursor-pointer
									hover:bg-yellow-50
								"
								@click="scrollRight()"
							>
								<svg
									fill="none"
									height="16"
									viewBox="0 0 16 16"
									width="16"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M6 12L10 8L6 4"
										stroke="#48566A"
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="1.33333"
									/>
								</svg>
							</div>
						</div>
					</div>
					<div v-else>
						<div class="text-center text-neutral-500">
							Mục tiêu chưa có phản hồi nào từ Phụ huynh.
						</div>
					</div>
				</div>
				<div class="relative my-12">
					<div
						aria-hidden="true"
						class="absolute inset-0 flex items-center"
					>
						<div class="w-full border-t border-neutral-300" />
					</div>
					<div class="relative flex justify-center">
						<div
							class="
								px-2.5
								py-1
								bg-white
								text-neutral-600
								font-semibold
								pb-1
								text-2xl
							"
						>
							Lịch sử của mục tiêu
						</div>
					</div>
				</div>
				<div class="mt-14">
					<div v-if="goal?.completed_at" class="relative mt-12">
						<div
							aria-hidden="true"
							class="absolute inset-0 flex items-center"
						>
							<div class="w-full border-t border-neutral-300" />
						</div>
						<div
							class="
								relative
								flex
								items-center
								justify-between
								mb-2
							"
						>
							<span
								class="
									pr-3
									bg-body
									text-lg
									font-semibold
									text-neutral-600
								"
							>
								{{ $filters.formatDate(goal?.completed_at) }}
							</span>
							<div
								class="
									pl-3
									bg-body
									text-neutral-600
									flex
									items-center
								"
							>
								<span class="mr-2">Hoàn thành mục tiêu</span>
								<svg
									fill="none"
									height="20"
									viewBox="0 0 20 20"
									width="20"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										clip-rule="evenodd"
										d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM15.0379 6.21209C14.6718 5.84597 14.0782 5.84597 13.7121 6.21209C13.7032 6.22093 13.6949 6.23029 13.6872 6.24013L9.34673 11.7709L6.72983 9.15403C6.36372 8.78791 5.77012 8.78791 5.40401 9.15403C5.03789 9.52015 5.03789 10.1137 5.40401 10.4799L8.71207 13.7879C9.07818 14.154 9.67178 14.154 10.0379 13.7879C10.046 13.7798 10.0537 13.7712 10.0609 13.7622L15.0512 7.52434C15.404 7.15727 15.3995 6.57371 15.0379 6.21209Z"
										fill="#2AA797"
										fill-rule="evenodd"
									/>
								</svg>
							</div>
						</div>
					</div>
					<div
						v-for="(assStop, index) in assessmentsAfterStop"
						:key="index"
					>
						<div class="mt-10">
							<div class="font-semibold text-neutral-600 text-lg">
								{{ assStop.tag }}
							</div>
						</div>
						<div
							class="
								shadow-sm
								sm:rounded-2xl
								overflow-hidden
								mt-8
							"
						>
							<div class="overflow-x-auto scroll-bar">
								<div
									class="
										overflow-hidden
										sm:rounded-t-2xl
										w-fit
										min-w-full
									"
								>
									<table
										class="
											min-w-full
											divide-y
											text-neutral-200
										"
									>
										<thead class="bg-neutral-100 h-16">
											<tr>
												<th
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
														w-16
													"
													scope="col"
												>
													STT
												</th>
												<th
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
													scope="col"
												>
													Ngày
												</th>
												<th
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														whitespace-nowrap
														tracking-wider
													"
													scope="col"
												>
													Kết quả
												</th>
												<th
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
													scope="col"
												>
													Cảm xúc
												</th>
												<th
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
													scope="col"
													style="width: 350px"
												>
													Hoạt động
												</th>
												<th
													class="
														px-3
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
													scope="col"
													style="width: 100px"
												>
													ALBUM
												</th>
												<th
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
													scope="col"
													style="width: 350px"
												>
													Ghi chú
												</th>
											</tr>
										</thead>
										<tbody>
											<tr
												v-for="(
													assessments, index
												) in assStop.assessments"
												:key="index"
												:class="
													index % 2 === 0
														? 'bg-white'
														: 'bg-neutral-50'
												"
												class="text-neutral-700"
											>
												<td
													class="
														px-6
														py-4
														whitespace-nowrap
														text-neutral-700
													"
												>
													<div class="ml-4">
														{{ index + 1 }}
													</div>
												</td>
												<td
													class="
														px-6
														py-4
														whitespace-nowrap
														text-neutral-700
													"
													style="width: 150px"
												>
													<div>
														{{
															$filters.formatDate2(
																assessments
																	.lesson_report
																	.date
															)
														}}
													</div>
												</td>
												<td
													class="
														px-6
														py-4
														whitespace-nowrap
														text-neutral-700
													"
													style="width: 150px"
												>
													<div>
														<div
															:style="{
																background:
																	$filters.tagResult(
																		assessments.result
																	)
																		?.background,
																color: $filters.tagResult(
																	assessments.result
																)?.color,
															}"
															class="
																mt-1
																py-0.5
																px-2.5
																rounded-full
																text-neutral-700
																h-fit
																w-fit
																font-semibold
																text-sm
																shadow-input
															"
														>
															{{
																assessments.result
															}}
														</div>
													</div>
												</td>
												<td
													class="
														px-6
														py-4
														whitespace-nowrap
														text-neutral-700
													"
													style="width: 100px"
												>
													<div>
														<div
															class="
																whitespace-normal
															"
														>
															<img
																v-if="
																	assessments
																		.lesson_report
																		.emotion_scale
																"
																:src="
																	require(`@/assets/images/emoji/${
																		$filters.emoji(
																			assessments
																				.lesson_report
																				.emotion_scale +
																				''
																		).emoji
																	}`)
																"
																alt=""
																height="30"
																width="30"
															/>
														</div>
													</div>
												</td>
												<td
													class="
														px-6
														py-4
														whitespace-nowrap
														text-neutral-700
													"
												>
													<div>
														<div
															v-if="
																assessments.activities
															"
														>
															<div
																v-for="a in assessments.activities"
																:key="a.id"
																class="mb-2"
															>
																{{ a.name }}
															</div>
														</div>
													</div>
												</td>
												<td
													class="
														whitespace-nowrap
														text-neutral-700
													"
												>
													<div
														v-if="
															haveMediaByLessonId(
																assessments
																	?.lesson_report
																	?.id
															)
														"
														class="pl-5 py-4"
														@click="
															openMediaPopup(
																[
																	haveMediaByLessonId(
																		assessments
																			?.lesson_report
																			?.id
																	),
																],
																0
															)
														"
													>
														<svg
															fill="none"
															height="20"
															viewBox="0 0 20 20"
															width="20"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																clip-rule="evenodd"
																d="M15 5H2.5C1.80964 5 1.25 5.55964 1.25 6.25V16.25L4.55806 13.3081C4.76872 13.0974 5.0988 13.0647 5.34669 13.23L8.67036 15.4458L13.3081 10.8081C13.4983 10.6179 13.7889 10.5707 14.0295 10.691L16.25 13.125V6.25C16.25 5.55964 15.6904 5 15 5ZM2.5 3.75C1.11929 3.75 0 4.86929 0 6.25V16.25C0 17.6307 1.11929 18.75 2.5 18.75H15C16.3807 18.75 17.5 17.6307 17.5 16.25V6.25C17.5 4.86929 16.3807 3.75 15 3.75H2.5ZM7.5 9.375C7.5 10.4105 6.66053 11.25 5.625 11.25C4.58947 11.25 3.75 10.4105 3.75 9.375C3.75 8.33947 4.58947 7.5 5.625 7.5C6.66053 7.5 7.5 8.33947 7.5 9.375Z"
																fill="#E5A42B"
																fill-rule="evenodd"
															/>
															<path
																clip-rule="evenodd"
																d="M4.5 2.25H18C18.5523 2.25 19 2.69772 19 3.25V14.25C19 14.8023 18.5523 15.25 18 15.25H17.5V16.25H18C19.1046 16.25 20 15.3546 20 14.25V3.25C20 2.14543 19.1046 1.25 18 1.25H4.5C3.39543 1.25 2.5 2.14543 2.5 3.25V3.75H3.5V3.25C3.5 2.69772 3.94772 2.25 4.5 2.25Z"
																fill="#E5A42B"
																fill-rule="evenodd"
															/>
														</svg>
													</div>
												</td>
												<td
													class="
														px-6
														py-4
														whitespace-nowrap
														text-neutral-700
													"
													style="
														width: 300px;
														min-width: 300px;
													"
												>
													<div>
														<div
															class="
																whitespace-normal
															"
														>
															{{
																assessments.note
															}}
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="mt-14">
					<div v-if="goal?.stopped_at" class="relative mt-12">
						<div
							aria-hidden="true"
							class="absolute inset-0 flex items-center"
						>
							<div class="w-full border-t border-neutral-300" />
						</div>
						<div
							class="
								relative
								flex
								items-center
								justify-between
								mb-2
							"
						>
							<span
								class="
									pr-3
									bg-body
									text-lg
									font-semibold
									text-neutral-600
								"
							>
								{{ $filters.formatDate(goal?.stopped_at) }}
							</span>
							<div
								class="
									pl-3
									bg-body
									text-neutral-600
									flex
									items-center
								"
							>
								<span class="mr-2">Tạm dừng mục tiêu</span>
								<svg
									fill="none"
									height="20"
									viewBox="0 0 20 20"
									width="20"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										clip-rule="evenodd"
										d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM5.83333 9.16667C5.48816 9.16667 5.20833 9.53976 5.20833 10C5.20833 10.4602 5.48816 10.8333 5.83333 10.8333H14.5833C14.9285 10.8333 15.2083 10.4602 15.2083 10C15.2083 9.53976 14.9285 9.16667 14.5833 9.16667H5.83333Z"
										fill="#E37056"
										fill-rule="evenodd"
									/>
								</svg>
							</div>
						</div>
					</div>
					<div
						v-for="(assStop, assStopIndex) in assessmentsBeforeStop"
						:key="assStopIndex"
					>
						<div class="mt-10">
							<div class="font-semibold text-neutral-600 text-lg">
								{{ assStop.tag }}
							</div>
						</div>
						<div
							class="
								shadow-sm
								sm:rounded-2xl
								overflow-hidden
								mt-8
							"
						>
							<div class="overflow-x-auto scroll-bar">
								<div
									class="
										overflow-hidden
										sm:rounded-t-2xl
										w-fit
										min-w-full
									"
								>
									<table
										class="
											min-w-full
											divide-y
											text-neutral-200
										"
									>
										<thead class="bg-neutral-100 h-16">
											<tr>
												<th
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
														w-16
													"
													scope="col"
												>
													STT
												</th>
												<th
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
													scope="col"
												>
													Ngày
												</th>
												<th
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														whitespace-nowrap
														tracking-wider
													"
													scope="col"
												>
													Kết quả
												</th>
												<th
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
													scope="col"
												>
													Cảm xúc
												</th>
												<th
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
													scope="col"
													style="width: 350px"
												>
													Hoạt động
												</th>
												<th
													class="
														px-3
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
													scope="col"
													style="width: 100px"
												>
													ALBUM
												</th>
												<th
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
													scope="col"
													style="width: 350px"
												>
													Ghi chú
												</th>
											</tr>
										</thead>
										<tbody>
											<tr
												v-for="(
													assessments, index
												) in assStop.assessments"
												:key="index"
												:class="
													index % 2 === 0
														? 'bg-white'
														: 'bg-neutral-50'
												"
												class="text-neutral-700"
											>
												<td
													class="
														px-6
														py-4
														whitespace-nowrap
														text-neutral-700
													"
												>
													<div class="ml-4">
														{{
															noArray[
																assessments.id
															]
														}}
													</div>
												</td>
												<td
													class="
														px-6
														py-4
														whitespace-nowrap
														text-neutral-700
													"
													style="width: 150px"
												>
													<div>
														{{
															$filters.formatDate2(
																assessments
																	.lesson_report
																	.date
															)
														}}
													</div>
												</td>
												<td
													class="
														px-6
														py-4
														whitespace-nowrap
														text-neutral-700
													"
													style="width: 150px"
												>
													<div>
														<div
															:style="{
																background:
																	$filters.tagResult(
																		assessments.result
																	)
																		?.background,
																color: $filters.tagResult(
																	assessments.result
																)?.color,
															}"
															class="
																mt-1
																py-0.5
																px-2.5
																rounded-full
																text-neutral-700
																h-fit
																w-fit
																font-semibold
																text-sm
																shadow-input
															"
														>
															{{
																assessments.result
															}}
														</div>
													</div>
												</td>
												<td
													class="
														px-6
														py-4
														whitespace-nowrap
														text-neutral-700
													"
													style="width: 100px"
												>
													<div>
														<div
															class="
																whitespace-normal
															"
														>
															<img
																v-if="
																	assessments
																		.lesson_report
																		.emotion_scale
																"
																:src="
																	require(`@/assets/images/emoji/${
																		$filters.emoji(
																			assessments
																				.lesson_report
																				.emotion_scale +
																				''
																		).emoji
																	}`)
																"
																alt=""
																height="30"
																width="30"
															/>
														</div>
													</div>
												</td>
												<td
													class="
														px-6
														py-4
														whitespace-nowrap
														text-neutral-700
													"
												>
													<div>
														<div
															v-if="
																assessments.activities
															"
														>
															<div
																v-for="a in assessments.activities"
																:key="a.id"
																class="mb-2"
															>
																{{ a.name }}
															</div>
														</div>
													</div>
												</td>
												<td
													class="
														whitespace-nowrap
														text-neutral-700
													"
												>
													<div
														v-if="
															haveMediaByLessonId(
																assessments
																	?.lesson_report
																	?.id
															)
														"
														class="pl-5 py-4"
														@click="
															openMediaPopup(
																[
																	haveMediaByLessonId(
																		assessments
																			?.lesson_report
																			?.id
																	),
																],
																0
															)
														"
													>
														<svg
															fill="none"
															height="20"
															viewBox="0 0 20 20"
															width="20"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																clip-rule="evenodd"
																d="M15 5H2.5C1.80964 5 1.25 5.55964 1.25 6.25V16.25L4.55806 13.3081C4.76872 13.0974 5.0988 13.0647 5.34669 13.23L8.67036 15.4458L13.3081 10.8081C13.4983 10.6179 13.7889 10.5707 14.0295 10.691L16.25 13.125V6.25C16.25 5.55964 15.6904 5 15 5ZM2.5 3.75C1.11929 3.75 0 4.86929 0 6.25V16.25C0 17.6307 1.11929 18.75 2.5 18.75H15C16.3807 18.75 17.5 17.6307 17.5 16.25V6.25C17.5 4.86929 16.3807 3.75 15 3.75H2.5ZM7.5 9.375C7.5 10.4105 6.66053 11.25 5.625 11.25C4.58947 11.25 3.75 10.4105 3.75 9.375C3.75 8.33947 4.58947 7.5 5.625 7.5C6.66053 7.5 7.5 8.33947 7.5 9.375Z"
																fill="#E5A42B"
																fill-rule="evenodd"
															/>
															<path
																clip-rule="evenodd"
																d="M4.5 2.25H18C18.5523 2.25 19 2.69772 19 3.25V14.25C19 14.8023 18.5523 15.25 18 15.25H17.5V16.25H18C19.1046 16.25 20 15.3546 20 14.25V3.25C20 2.14543 19.1046 1.25 18 1.25H4.5C3.39543 1.25 2.5 2.14543 2.5 3.25V3.75H3.5V3.25C3.5 2.69772 3.94772 2.25 4.5 2.25Z"
																fill="#E5A42B"
																fill-rule="evenodd"
															/>
														</svg>
													</div>
												</td>
												<td
													class="
														px-6
														py-4
														whitespace-nowrap
														text-neutral-700
													"
													style="
														width: 300px;
														min-width: 300px;
													"
												>
													<div>
														<div
															class="
																whitespace-normal
															"
														>
															{{
																assessments.note
															}}
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="mt-14">
					<div class="relative mt-12">
						<div
							aria-hidden="true"
							class="absolute inset-0 flex items-center"
						>
							<div class="w-full border-t border-neutral-300" />
						</div>
						<div
							class="
								relative
								flex
								items-center
								justify-between
								mb-2
							"
						>
							<span
								class="
									pr-3
									bg-body
									text-lg
									font-semibold
									text-neutral-600
								"
							>
								{{ $filters.formatDate(goal?.inserted_at) }}
							</span>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="fixed top-1/2 left-1/2">
				<Loading />
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed, defineProps, onMounted, ref, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { $api } from '@/services';
import { useStudent } from '@/features/student/useStudent';
import { useStore } from 'vuex';
import ViewPhoto from '@/components/common/ViewPhoto';
import Loading from '@/components/common/Loading';
import { timeSinceHour } from '@/helper/formatDate';

const router = useRouter();
const route = useRoute();
const store = useStore();
const org = computed(() => store.state.profile.current_org);
const student = ref(null);
const goal = ref(null);
const assessmentsBeforeStop = ref([]);
const assessmentsAfterStop = ref([]);
const seriesData = ref([]);
const series_ = ref([]);
const imageShow = ref(false);
const isLoading = ref(true);
const photosIndex = ref(0);
const photos = ref([]);
const id = ref(route.params.id);
const noArray = ref([]);
const props = defineProps(['sideOverShow', 'goalId']);
const chartOptions = ref({
	colors: ['#2AA797'],
	chart: {
		type: 'line',
		zoom: {
			enabled: false,
		},
		animations: {
			enabled: false,
		},
	},
	stroke: {
		width: 3,
	},
	yaxis: {
		labels: {
			show: false,
		},
		max: 100,
		min: 0,
		tickAmount: 5,
	},
	grid: {
		show: true,
		borderColor: '#F1F5F9',
	},
	markers: {
		size: 8,
		strokeColors: '#fff',
		strokeWidth: 2,
	},
});
watch(
	() => props.goalId,
	() => {
		isLoading.value = true;
		fetchStudent();
		fetchGoalDetailWidthAssessment();
	}
);
onMounted(() => {
	if (props.goalId) {
		fetchStudent();
		fetchGoalDetailWidthAssessment();
	}
	setTimeout(() => {
		const feedbackBox = document.getElementById('feedback-box');
		if (feedbackBox) {
			scrollable.value =
				feedbackBox?.scrollWidth > feedbackBox?.clientWidth;
		}
	}, 1000);
});

async function fetchGoalDetailWidthAssessment() {
	try {
		const {
			data: { data },
		} = await $api.goal.goalDetailWidthAssessment(
			String(props.goalId || ''),
			String(id.value || '')
		);
		goal.value = data?.goal;
		assessmentsBeforeStop.value = data?.assessment_groups?.before_stops;
		let total = 0;
		assessmentsBeforeStop.value.forEach((item) => {
			total += item.assessments?.length;
		});
		assessmentsBeforeStop.value.forEach((item) => {
			item.assessments.forEach((assessment) => {
				noArray.value[assessment.id] = total;
				total -= 1;
			});
		});
		assessmentsAfterStop.value = data?.assessment_groups?.after_stops;
		let assessments = [];
		[
			...assessmentsBeforeStop.value,
			...assessmentsAfterStop.value,
		].forEach((assItem) => {
			const tmp = [...assessments];
			const tmp2 = [...assItem.assessments];
			assessments = [...tmp, ...tmp2];
		});
		seriesData.value = assessments.map((item) => {
			return +item.complete_percent;
		});
		series_.value = [
			{
				name: 'Kết quả buổi học',
				data: seriesData.value,
			},
		];
		isLoading.value = false;
	} catch (e) {
		console.log(e);
	}
}

const { getStudent } = useStudent();

async function fetchStudent() {
	const res = await getStudent(String(id.value || ''));
	if (res?.data) {
		student.value = res?.data;
	}
}

function countMedia(g) {
	return g?.goal_media >= 6 ? 6 : g?.goal_media?.length;
}

function openMediaPopup(media, index) {
	imageShow.value = true;
	photos.value = media;
	photosIndex.value = index;
}

function haveMediaByLessonId(lessonId) {
	return goal.value?.goal_media?.find(
		(item) => item.lesson_report_id === lessonId
	);
}

function loadThumbnail(asset) {
	const imageRequest = JSON.stringify({
		bucket: asset.image_bucket,
		key: asset.video_poster_asset_key,
		edits: {
			width: 400,
			height: 400,
		},
	});
	return `${asset.image_cloudfront_url}/${btoa(imageRequest)}`;
}

function loadImage(asset) {
	const imageRequest = JSON.stringify({
		bucket: asset.image_bucket,
		key: asset.asset_key,
		edits: {
			width: 400,
			height: 400,
		},
	});
	return `${asset.image_cloudfront_url}/${btoa(imageRequest)}`;
}

const scrollable = ref(false);

function scrollLeft() {
	const feedbackBox = document.getElementById('feedback-box');
	if (feedbackBox) {
		const position = feedbackBox.scrollLeft;
		feedbackBox.scrollTo({
			left: position - 800,
			behavior: 'smooth',
		});
	}
}

function scrollRight() {
	const feedbackBox = document.getElementById('feedback-box');
	if (feedbackBox) {
		const position = feedbackBox.scrollLeft;
		feedbackBox.scrollTo({
			left: position + 800,
			behavior: 'smooth',
		});
	}
}

function getStatus(state) {
	switch (state) {
		case 'completed':
			return `<div class=" flex items-center gap-2">
                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5ZM12.0303 5.46967C11.7374 5.17678 11.2625 5.17678 10.9697 5.46967C10.9626 5.47674 10.9559 5.48424 10.9498 5.4921L7.47739 9.91674L5.38387 7.82322C5.09097 7.53033 4.6161 7.53033 4.32321 7.82322C4.03031 8.11612 4.03031 8.59099 4.32321 8.88388L6.96965 11.5303C7.26255 11.8232 7.73742 11.8232 8.03031 11.5303C8.03684 11.5238 8.04299 11.5169 8.04875 11.5097L12.041 6.51947C12.3232 6.22582 12.3196 5.75897 12.0303 5.46967Z" fill="#2AA797"/>
                  </svg>
                  <span class="text-neutral-700"> Hoàn thành </span>
                  </div>`;
		case 'stopped':
			return `<div class=" flex items-center gap-2">
                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5ZM12.1667 8.49677C12.1653 8.13006 11.942 7.83333 11.6667 7.83333H4.66667C4.39052 7.83333 4.16667 8.13181 4.16667 8.5C4.16667 8.86819 4.39052 9.16667 4.66667 9.16667H11.6667C11.942 9.16667 12.1653 8.86994 12.1667 8.50323C12.1667 8.50216 12.1667 8.50108 12.1667 8.5C12.1667 8.49892 12.1667 8.49784 12.1667 8.49677Z" fill="#E37056"/>
                  </svg>
                  <span class="text-neutral-700"> Tạm dừng </span>
                  </div>`;
		case 'library':
			return `
                  <div class="text-neutral-700">Ngân hàng MT</div>
                  `;
		case 'active':
			return `<div class=" flex items-center gap-2">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				  <path fill-rule="evenodd" clip-rule="evenodd" d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8 3.5C8 3.22386 7.77614 3 7.5 3C7.22386 3 7 3.22386 7 3.5V9C7 9.17943 7.09614 9.3451 7.25193 9.43412L10.7519 11.4341C10.9917 11.5711 11.2971 11.4878 11.4341 11.2481C11.5711 11.0083 11.4878 10.7029 11.2481 10.5659L8 8.70984V3.5Z" fill="#6390C3"/>
			      </svg>
                  <span class="text-neutral-700"> Đang học </span>
                  </div>`;
		default:
			return '';
	}
}
</script>
<style scoped>
.w-720 {
	width: 720px !important;
}
</style>
